import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Distributor, HttpDataService } from 'core/index';
import { BrokerCreditsDealerService } from '../broker-credits-dealer.service';

@Component({
  selector: 'lms-broker-credits-sales',
  templateUrl: './broker-credits-sales.component.html',
  styleUrls: ['./broker-credits-sales.component.scss']
})
export class BrokerCreditsSalesComponent implements OnInit, OnChanges {
  @Input() distributor: Distributor;
  @Input() listId = 'DISTRIBUTOR_CREDITS_SALES_LIST';
  @Input() hideCredits = false;

  public dataService: HttpDataService;
  public sales: any[];
  public filters: Map<string, string>;

  constructor(public dealerService: BrokerCreditsDealerService) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.distributor) {
      this.dataService = this.dealerService.getSalesDataService(this.distributor);
    }
  }

  setCollection(sales) {
    this.sales = sales;
  }
}
